import React from 'react';

interface CloseIcon {
    width: number;
    height: number;
    color: string;
}

export const CloseIcon = ({
    width = 14, 
    height= 14, 
    color = '#555555'
}: CloseIcon) => 
    <svg id='Layer_1' x='0px' y='0px' width={width} height={height} fill={color} style={{ cursor: 'pointer' }} viewBox='0 0 12.7 12.7' enableBackground='new 0 0 12.7 12.7' xmlSpace='preserve'>
        <path fillRule='evenodd' clipRule='evenodd' d='M0.3,11.2c-0.3,0.3-0.3,0.9,0,1.2l0,0c0.3,0.3,0.9,0.3,1.2,0l11-11 c0.3-0.3,0.3-0.9,0-1.2l0,0c-0.3-0.3-0.9-0.3-1.2,0L0.3,11.2L0.3,11.2z M0.3,11.2'/>
        <path fillRule='evenodd' clipRule='evenodd' d='M12.5,11.2c0.3,0.3,0.3,0.9,0,1.2l0,0c-0.3,0.3-0.9,0.3-1.2,0l-11-11 c-0.3-0.3-0.3-0.9,0-1.2l0,0c0.3-0.3,0.9-0.3,1.2,0L12.5,11.2L12.5,11.2z M12.5,11.2'/>
    </svg>
;
